<template>
  <g>
    <path
      d="M17 4.00018C16.45 4.00018 16 4.45018 16 5.00018V11.9002L18 9.90018V5.00018C18 4.45018 17.55 4.00018 17 4.00018Z"
    />
    <path
      d="M5 20.0002C5.55 20.0002 6 19.5502 6 19.0002V5.00018C6 4.45018 5.55 4.00018 5 4.00018C4.45 4.00018 4 4.45018 4 5.00018V19.0002C4 19.5502 4.45 20.0002 5 20.0002Z"
    />
    <path
      d="M11 8.00018C11.55 8.00018 12 7.55018 12 7.00018V5.00018C12 4.45018 11.55 4.00018 11 4.00018C10.45 4.00018 10 4.45018 10 5.00018V7.00018C10 7.55018 10.45 8.00018 11 8.00018Z"
    />
    <path
      d="M11 14.0002C11.55 14.0002 12 13.5502 12 13.0002V11.0002C12 10.4502 11.55 10.0002 11 10.0002C10.45 10.0002 10 10.4502 10 11.0002V13.0002C10 13.5502 10.45 14.0002 11 14.0002Z"
    />
    <path
      d="M11 20.0002C11.55 20.0002 12 19.5502 12 19.0002V17.0002C12 16.4502 11.55 16.0002 11 16.0002C10.45 16.0002 10 16.4502 10 17.0002V19.0002C10 19.5502 10.45 20.0002 11 20.0002Z"
    />
    <path
      d="M22.56 12.5902L21.41 11.4402C20.82 10.8502 19.87 10.8502 19.29 11.4402L14 16.7302V19.5002C14 19.7802 14.22 20.0002 14.5 20.0002H17.27L22.56 14.7102C23.15 14.1202 23.15 13.1702 22.56 12.5902ZM16.58 18.4502H15.55V17.4202L19 13.9702L20.03 15.0002L16.58 18.4502Z"
    />
  </g>
</template>
